import React from "react";
import { connect } from "react-redux";
import IngresoActions from "../../../stores/ingreso/Actions";
import { formatearMontoPesos } from "../../../utils/CurrencyUtil";
import CustomTable from "../../../components/CustomTable/CustomTable";

const ProcedimientosIngresoDetalle = (props) => {
  const { formCierreCuentasData } = props;

  const columnasProcedimientos = [
    {
      key: "cobertura",
      title: "Código",
      dataIndex: "cobertura",
    },
    {
      key: "nombreCobertura",
      title: "Descripción",
      dataIndex: "nombreCobertura",
    },
    {
      key: "tipoReclamante",
      title: "Tipo reclamante",
      dataIndex: "tipoReclamante",
    },
    {
      key: "codigoReclamante",
      title: "Código reclamante",
      dataIndex: "codigoReclamante",
    },
    {
      key: "nombreReclamante",
      title: "Reclamante",
      dataIndex: "nombreReclamante",
    },
    {
      key: "limiteContrato",
      title: "Limite contrato",
      dataIndex: "limiteContrato",
      render: (text) => formatearMontoPesos(String(text)),
    },
    {
      key: "frecuencia",
      title: "Frecuencia",
      dataIndex: "frecuencia",
    },
    {
      key: "montoReclamado",
      title: "Monto reclamado",
      dataIndex: "montoReclamado",
      render: (text) => formatearMontoPesos(String(text)),
    },
    {
      key: "montoAutorizado",
      title: "Monto a pagar ARS",
      dataIndex: "montoAutorizado",
      render: (text) => formatearMontoPesos(String(text)),
    },
    {
      key: "montoDiferencia",
      title: "Diferencia no cubierta",
      dataIndex: "montoDiferencia",
      render: (text) => formatearMontoPesos(String(text)),
    },
    {
      key: "coaseguro",
      title: "% coaseguro",
      dataIndex: "coaseguro",
    }
  ];

  return (
    <CustomTable
      columns={columnasProcedimientos}
      dataSource={formCierreCuentasData?.procedimientos || []}
      showPagination={false}
      pageSize={100}
      width={"200%"}
      maxWidth={"1400px"}
    />
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  formCierreCuentasData: state.ingreso.formCierreCuentasData,
  formCierreCuentasLoading: state.ingreso.formCierreCuentasLoading,
});

const mapDispatchToProps = {
  formCierreCuentas: IngresoActions.formCierreCuentas,
  eliminarProcedimientoCierreCuentas:
    IngresoActions.eliminarProcedimientoCierreCuentas,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(ProcedimientosIngresoDetalle);
